import React from 'react';
import FollowButton from '../Athletes/FollowButton';
import { formatNumber } from '../../src/js/lib/number';

const ContestantTooltip = ({ contestant, allowFollow }) => {
  const { name, slug, is_following, year, distance_covered, top_results } =
    contestant;

  return (
    <div className='min-w-[10rem]'>
      {/* Name and Follow Button */}
      <div className='flex items-center justify-between mb-4'>
        <h3 className='font-semibold text-lg truncate mb-0'>{name}</h3>
        {allowFollow && (
          <FollowButton
            athleteId={contestant.id}
            initialFollowing={is_following}
            simple={true}
          />
        )}
      </div>

      <div className='w-full grid grid-cols-2'>
        <div className='mb-4'>
          <h4 className='font-medium mb-2 text-base text-left'>{year}:</h4>
          <div className='text-sm text-left'>
            {distance_covered.cycling !== undefined && (
              <div className='block'>
                <span>Cycling: </span>
                <span className='font-medium'>
                  {formatNumber(distance_covered.cycling)} km
                </span>
              </div>
            )}
            {distance_covered.running !== undefined && (
              <div className='block'>
                <span>Running: </span>
                <span className='font-medium'>
                  {formatNumber(distance_covered.running)} km
                </span>
              </div>
            )}
          </div>
        </div>

        {top_results.ftp || top_results.max_watt ? (
          <div className='mb-4'>
            <h4 className='font-medium mb-2 text-base text-left'>
              Top result:
            </h4>
            <div className='text-sm text-left'>
              {top_results.ftp && (
                <div className='block'>
                  <span>FTP: </span>
                  <span className='font-medium'>
                    {formatNumber(top_results.ftp)}
                  </span>
                </div>
              )}
              {top_results.max_watt && (
                <div className='block'>
                  <span>Max watt: </span>
                  <span className='font-medium'>
                    {formatNumber(top_results.max_watt)}
                  </span>
                </div>
              )}
            </div>
          </div>
        ) : null}
      </div>

      {/* View profile link */}
      <div className='w-full text-left'>
        <a
          href={`/profile/${slug}`}
          className='mini-text underline font-medium'
        >
          View profile
        </a>
      </div>
    </div>
  );
};

export default ContestantTooltip;
